<div class="topbar" [class.is--open]="menuActive" [class.is--fixed]="fixed" [ngClass]="'direction--' + scrollDirection">
  <div class="topbar__bar">
    <div class="container topbar__bar__inner">
      <nav class="topbar__bar__nav-lists">
        <a class="topbar__bar__logo" [routerLink]="['/']">
          <svg xmlns="http://www.w3.org/2000/svg" width="189" height="76" fill="none" viewBox="0 0 189 76" title="Mijn Rova logo">
            <path
              class="logo-fill-theme"
              d="M69.199 44.805h-3.296v-5.856h3.258c1.384 0 3.864.07 3.864 2.947 0 2.84-2.517 2.909-3.826 2.909Zm6.59 3.868c1.168-.46 2.229-.85 3.22-1.915a7.034 7.034 0 0 0 1.915-5.04c0-2.415-.993-5.823-4.322-7.24-1.524-.642-3.79-.784-6.166-.784H57.97v25.094h7.933v-8.835h2.339l4.853 8.835h8.783L75.79 48.673ZM140.675 50.34l-4.426-16.609h-8.079l8.362 25.057h8.252l8.467-25.057h-8.114l-4.462 16.61ZM172.388 49.704l2.727-8.838 2.655 8.838h-5.382Zm7.258-15.973h-8.993l-9.565 25.058h8.5l1.097-3.477h8.717l1.097 3.477H189l-9.354-25.058ZM114.43 37.651l-7.219 4.194a4.708 4.708 0 0 1 2.899 4.05 4.726 4.726 0 0 1-2.346 4.394l-14.791 8.452h12.375a12.46 12.46 0 0 0 6.862-2.054 12.497 12.497 0 0 0 4.605-5.496 12.527 12.527 0 0 0-2.385-13.54Z"
            />
            <path
              class="logo-fill-theme"
              d="m96.333 54.819 7.421-4.271a4.671 4.671 0 0 1-2.501-6.574 4.66 4.66 0 0 1 1.825-1.876l14.636-8.426-12.302-.007a12.476 12.476 0 0 0-6.255 1.662 12.506 12.506 0 0 0-4.587 4.576 12.537 12.537 0 0 0 1.763 14.916Z"
            />
            <path
              fill="#ED1C24"
              d="m31.014 33.483-.448.648a2.86 2.86 0 0 0 .653 3.962c1.262.915 2.857.434 3.922-.659.893-.915 3.32-4.768 3.882-6.41.564-1.642-.074-3.022-1.488-3.668-1.419-.648-2.781.176-3.72 1.775-.94 1.602-1.726 2.659-2.801 4.351"
            />
            <path
              class="logo-fill-theme"
              d="M41.01 18.767c.262.438.717.41.61.086 0 0-1.313-4.655-7.94-5.687-6.243-.977-9.166 2.681-9.166 2.681s-1.066 1.414.304.568a14.353 14.353 0 0 1 7.97-1.829c3.014.223 5.354.777 8.223 4.181ZM41.803 20.476s-1.097.747-.7 1.817l7.013-.642s-3.398-1.242-6.313-1.175ZM46.6 22.216l-5.303.831c-.199.013-1.12.31-1.026.773.094.467.89.754 2.554.241 1.669-.514 3.048-1.056 3.775-1.845ZM84.694 16.371c1.03 0 1.81.254 2.338.76.529.503.793 1.311.793 2.426v5.659h-1.3v-5.572c0-.723-.166-1.265-.5-1.624-.327-.36-.831-.54-1.513-.54-.962 0-1.638.273-2.029.817-.39.544-.586 1.334-.586 2.37v4.549H80.58V16.53h1.062l.198 1.252h.072c.184-.307.42-.563.705-.769.285-.211.605-.37.959-.476.354-.11.726-.166 1.117-.166ZM75.43 29.115c-.27 0-.505-.02-.706-.063a3.404 3.404 0 0 1-.523-.135v-1.07c.164.053.33.093.5.12.169.03.359.047.57.047.36 0 .65-.1.872-.301.222-.201.333-.566.333-1.094v-10.09h1.315v10.058c0 .529-.084.98-.253 1.355a1.84 1.84 0 0 1-.777.872c-.349.201-.792.301-1.331.301Zm.927-14.97c0-.297.074-.513.222-.65a.806.806 0 0 1 .57-.215c.217 0 .402.072.555.214.159.138.238.354.238.65 0 .29-.08.507-.238.65a.785.785 0 0 1-.554.214.806.806 0 0 1-.571-.214c-.148-.143-.222-.36-.222-.65ZM73.686 16.53v8.686H72.37V16.53h1.316Zm-.642-3.25c.217 0 .402.072.555.214.158.138.238.354.238.65 0 .29-.08.507-.238.65a.785.785 0 0 1-.555.214.805.805 0 0 1-.57-.214c-.149-.143-.223-.36-.223-.65 0-.296.074-.512.222-.65a.805.805 0 0 1 .571-.214ZM63.066 25.216 59.174 14.96h-.063c.021.217.04.481.056.793a46.814 46.814 0 0 1 .055 2.14v7.323H57.97V13.629h1.997l3.67 9.637h.055l3.725-9.637h1.981v11.587h-1.331v-7.418c0-.344.005-.687.016-1.03a45.41 45.41 0 0 1 .087-1.792h-.064l-3.938 10.24h-1.102ZM15.206 45.839c-.178.354 6.47 13.608 7.08 14.485a1.118 1.118 0 0 0 1.206.402c.41-.134.077-.642-.41-1.473-2.775-4.703-5.638-12.356-6.3-12.803-.661-.447-1.403-.967-1.576-.612M23.578 48.222c.57.965 6.826 10.141 7.77 10.703.674.4 1.221-.001 1.032-.236-.413-.513-2.691-3.837-4.306-6.16-2.744-3.945-2.903-4.748-3.608-4.927-.71-.177-1.14.19-.889.62M24.113 61.393c-1.38-.104-2.969-.356-3.408.036-.527.47-.665 1.471 1.191 1.537 1.853.066 5.202.102 5.164-.544-.028-.472-.989-.889-2.947-1.03M36.487 60.899c-.4.92-6.317.5-6.646.365-.333-.133-.877-.584-.084-1.186.795-.602 4.921-.111 4.921-.111s1.863.288 1.809.932ZM25.719 32.544c-.106-.816-.232-.036-.243-.105a11.285 11.285 0 0 1-2.371 3.515c-1.403 1.501-3.742 3.124-5.451 4.156-6.718 4.076-13.319 6.352-13.364 6.681-.049.33.513.313 1.545-.048 2.283-.783 10.852-4.313 13.835-6.253 2.835-1.84 6.547-4.084 6.049-7.946M16.28 44.99s-.377.097-.002.357c.963.673 4.67 1.982 9.63.923 3.844-.82 12.518-3.689 14.357-14.972.142-.872-.191-.505-.297-.364-.106.141-5.053 17.35-23.687 14.056ZM13.88 45.471c.278.338-.638.92-.638.92-1.057.851-2.182 1.668-5.067 3.943-2.298 1.813-4.182 3.463-4.76 4.028-1.078 1.05-1.421 1.391-1.737 1.391 0 0-1.874.12-1.661-.194.86-1.277 3.904-3.412 5.378-4.553 3.343-2.568 5.462-4.188 7.565-5.61 0 0 .57-.369.92.075ZM34.476 19.186l-.107.53a.755.755 0 0 1-1.162.48.752.752 0 0 1-.314-.782l.114-.562a2.16 2.16 0 0 0-1.872 2.05 2.169 2.169 0 0 0 1.68 2.209 2.158 2.158 0 0 0 2.468-1.267 2.17 2.17 0 0 0-.807-2.658Z"
            />
          </svg>
        </a>

        <ul class="nav-list-bar">
          <li class="" *ngFor="let page of filteredQuickMenuItems">
            <fstr-link
              [button]="{ text: page.title, url: page.url || '', routerLink: page.routerLink }"
              [routerLinkActive]="' is--active'"
              [routerLinkActiveOptions]="{ exact: isHomeUrl(page.url) }"
              cssClasses="button button--space-gray--secondary"
            ></fstr-link>
          </li>
        </ul>
      </nav>

      <nav class="topbar-actions" *ngIf="address">
        <!-- TODO enable if notifications overview page is built -->
        <!--<button class="button button-icon button--primary bigger--icon">
          <fstr-icon [anchor]="'icon-bell-line'"></fstr-icon>
        </button>-->

        <a
          class="button button-icon button--primary bigger--icon"
          (click)="routeBackIfActive('/instellingen')"
          [routerLink]="['/', 'instellingen']"
          [routerLinkActive]="'is--active'"
        >
          <fstr-icon [anchor]="'icon-user-line'"></fstr-icon>
        </a>

        <button class="button button-icon button--secondary hamburger-button d-none d-lg-inline" (click)="toggleOverlay.emit()">
          <span class="sr-only">{{ menuActive ? 'Sluit menu' : 'Open menu' }}</span>
          <div class="hamburger" [class.is--active]="menuActive">
            <span class="hamburger__lines"></span>
          </div>
        </button>
      </nav>
    </div>
  </div>

  <div class="topbar__overlay" [class.is--open]="menuActive" [cdkTrapFocus]="menuActive">
    <div class="topbar__overlay__backdrop" (click)="closeOverlay.emit()"></div>
    <nav class="topbar__overlay__nav">
      <div class="topbar__overlay__nav__inner" *ngIf="menuActive">
        <div>
          <ul class="mb-5 mt-4 nav-list nav-list--big">
            <li class="nav-list__item" *ngFor="let page of filteredQuickMenuItems">
              <fstr-link
                [button]="{ text: page.title, url: page.url || '', routerLink: page.routerLink }"
                [routerLinkActive]="'is--active'"
                [queryParams]="page.queryParams"
                [routerLinkActiveOptions]="{ exact: isHomeUrl(page.url) }"
                class="nav-link"
              ></fstr-link>
            </li>
          </ul>
          <ul class="nav-list nav-list--small">
            <li class="nav-list__item" *ngFor="let page of filteredMenuItems">
              <fstr-link
                [button]="{ text: page.title, url: page.url || '', routerLink: page.routerLink }"
                [routerLinkActive]="'is--active'"
                [queryParams]="page.queryParams"
                [routerLinkActiveOptions]="{ exact: isHomeUrl(page.url) }"
                class="nav-link"
              ></fstr-link>
            </li>
          </ul>
        </div>

        <ul class="nav-list-muted topbar__overlay__footer-menu">
          <li class="nav-list-muted__item" *ngFor="let page of filteredQuickFooterMenuItems">
            <fstr-link
              [button]="{ text: page.title, url: page.url || '', routerLink: page.routerLink }"
              [routerLinkActive]="'is--active'"
              [queryParams]="page.queryParams"
              [routerLinkActiveOptions]="{ exact: isHomeUrl(page.url) }"
              class="nav-link"
            ></fstr-link>
          </li>
          <li class="nav-list-muted__item">
            <button *ngIf="address$()" (click)="signOut()">
              {{ 'app-uitloggen-knoptekst' | fromDictionary }}
            </button>
          </li>
          <li class="nav-list-muted__item">{{ 'rova-copyright-tekst' | fromDictionary }}</li>
        </ul>
      </div>
      <!--<a href="/" class="button button--space-gray--secondary d-flex d-lg-none me-1 me-md-3">
          <fstr-icon [anchor]="'icon-arrow-left'"></fstr-icon>
          <span class="">{{ 'terug-naar-website-knoptekst' | fromDictionary }}</span>
        </a>-->
    </nav>
  </div>
</div>
